import $api from "../api/axios";

type TGlobalSettings = {
  id: number;
  defaultOpenAiModel: string;
  maxConcurrentAiCallsGpt: number;
  maxConcurrentAiCallsClaude: number;
  maxConcurrentAiCallsGemini: number;
  maxConcurrentAiCallsOther: number;
  maxConcurrentDbCalls: number;
};

export type GlobalSettingsError = {
  statusCode: number;
  error: string;
  message: string;
};

export type UpdateGlobalSettingsRequest = {
  defaultOpenAiModel?: string;
  maxConcurrentAiCallsGpt?: number;
  maxConcurrentAiCallsClaude?: number;
  maxConcurrentAiCallsGemini?: number;
  maxConcurrentAiCallsOther?: number;
  maxConcurrentDbCalls?: number;
};

export type GlobalSettingsResponse = {
  status: number;
  data: TGlobalSettings;
};

export async function getGlobalSettings(): Promise<TGlobalSettings> {
  const response = await $api.get("/admin/global-settings");
  return response.data;
}

export async function updateGlobalSettings(request: UpdateGlobalSettingsRequest): Promise<TGlobalSettings> {
  const response = await $api.patch("/admin/global-settings", request);
  return response.data;
}
